export type StaffTenantId = 'dhc' | 'ulybka' | string

export function staffTenantDisplayName(tenant: StaffTenantId): string {
  return tenant === 'dhc' ? 'DHC' : tenant === 'ulybka' ? 'УлыбкаPRO' : tenant
}

export function staffDashboardGreeting(tenant: StaffTenantId): string {
  return tenant === 'ulybka'
    ? 'Операционный день клиники'
    : 'Операционный день центра'
}

export function staffAppointmentsHint(tenant: StaffTenantId): string {
  return tenant === 'ulybka'
    ? 'Подтверждения и статусы приёмов из МИС УлыбкаPRO'
    : 'Подтверждения и статусы приёмов из МИС DHC'
}
